import DelegatedTokenManager from './DelegatedTokenManager';

class ConsentApiTokenManager extends DelegatedTokenManager {}

const consentApiTokenManager = new ConsentApiTokenManager('consents');
export default consentApiTokenManager;
